import Commons from '../../../../Services/Common/Common';

export const SAT_BASIC_06_Schema = {
  fields: {
    sheNm: { initial: '', label: '교육명' }, // 교육명
    shePeriod: { initial: '', label: '기간' }, // 기간
    sheTargetCount: { initial: 0, label: '교육대상자' }, // 교육대상자
    sheGraduate: { initial: 0, label: '이수자' }, // 이수자
    graduateRate: { initial: 0, label: '진행율(%)' }, // 진행율
  },

  mapper: {
    search1: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
      StartYear: (_, context) =>
        Commons.EncryptAES(context.search?.year.toString()) || '',
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || ''),
    },

    save1: {
      SheId: (row) => Commons.EncryptAES((row.sheId || 0).toString()) || '',
      SheGubun: (row) => Commons.EncryptAES(row.sheGubun) || '',
      SheNm: (row) => Commons.EncryptAES(row.sheNm || '') || '',
      SheTime: (row) => Commons.EncryptAES((row.sheTime || 0).toString()) || '',
      SheYn: (row) => Commons.EncryptAES(row.sheYn || 'OFF') || '',
      SheYear: (_, context) =>
        Commons.EncryptAES(context.search?.year.toString()) || '',
      ShePeriod: (row) => Commons.EncryptAES(row.shePeriod || '') || '',
      SheGraduate: (row) =>
        Commons.EncryptAES((row.sheGraduate || 0).toString()) || '',
      UserId: (_, context) => context.userInfo?.userid || '',
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
    },
  },
};
